export const types = {
	request: '[Catalogs] Request catalogs',
	catalogs: '[Catalogs] Request Success',
	catalogSelected: '[Catalogs] Catalog Selected',
	error: '[Catalogs] Request Error',
}
